import { Autocomplete, TextField } from '@mui/material'
import React from 'react'

interface Props {
    label: string;
    value: string;
    onChange: (value: string) => void;
    items: string[];
}

export default function RoundedInputSelect(props: Props) {
  const controlHeight = '44px'

  return (
    <Autocomplete
        freeSolo
        style={{
          width: '100%',
          minWidth: '100px',
          minHeight: controlHeight,
          height: controlHeight,
          color: '#132238',
        }}
        renderInput={(params) => 
          <TextField 
            {...params} 
            label={props.label} 
            variant='outlined'
            sx={{
              '& .MuiOutlinedInput-root': {
                minHeight: controlHeight,
                height: controlHeight,
                borderRadius: '14px',
                backgroundColor: '#ffffff',
                boxShadow: 'inset 0 1px 2px rgba(19, 34, 56, 0.03)',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#d8e0ea',
              },
              '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#c1ccd9',
              },
              '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: 'rgba(240, 184, 0, 0.9)',
              },
              '& .MuiOutlinedInput-root.Mui-focused': {
                boxShadow: '0 0 0 4px rgba(255, 203, 0, 0.18)',
              },
              '& .MuiInputBase-input': {
                boxSizing: 'border-box',
                color: '#132238',
                fontSize: '0.9rem',
                height: controlHeight,
                padding: '0 12px',
              },
              '& .MuiInputLabel-root': {
                color: '#5f6c7b',
                fontSize: '0.86rem',
              },
              '& .MuiInputLabel-root.Mui-focused': {
                color: '#132238',
              },
              '& .MuiAutocomplete-inputRoot': {
                padding: '0 36px 0 0 !important',
              },
              '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
                minWidth: 0,
              },
              '& .MuiAutocomplete-endAdornment .MuiSvgIcon-root': {
                fontSize: '1.1rem',
              },
            }}
          />
        }
        options={props.items}
        value={props.value ?? null}
        inputValue={props.value ?? ''}
        onInputChange={(_, value) => props.onChange(value)}
        onChange={(_, value) => props.onChange((value as string) ?? '')}
        sx={{
          color: "#132238",
          '.MuiOutlinedInput-notchedOutline': {
            borderColor: '#d8e0ea',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(240, 184, 0, 0.9)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#c1ccd9',
          },
          '.MuiSvgIcon-root ': {
            fill: "#132238",
          }
        }}
    />
  )
}
